/**
 * 登录接口
 */
import { baseURL } from '@/api/base' // 导入接口域名列表
import axios from '@/utils/http' // 导入http中创建的axios实例
//

export interface LoginParams {
	loginName: string
	loginPwd: string
}
export type Login = (params: LoginParams) => Promise<{ token: string }>

// 登录
export const login: Login = params => {
	return axios.post(`${baseURL}/api/login/adminLogin`, JSON.stringify(params), {
		hideLoading: true,
	})
}

export default { login }
